import { useCallback, useEffect, useRef } from "react";

/**
 * Whether the user's latest press was a key rather than a pointer. Read it
 * from an event handler, e.g. to tell an Enter on a card from a click.
 */
export const useIsLastPressKey = () => {
    const isKeyRef = useRef(false);

    useEffect(() => {
        const onKeyDown = () => {
            isKeyRef.current = true;
        };
        const onPointerDown = () => {
            isKeyRef.current = false;
        };
        document.addEventListener("keydown", onKeyDown, true);
        document.addEventListener("pointerdown", onPointerDown, true);
        return () => {
            document.removeEventListener("keydown", onKeyDown, true);
            document.removeEventListener("pointerdown", onPointerDown, true);
        };
    }, []);

    return useCallback(() => isKeyRef.current, []);
};
